import { z } from "zod";
import { alertTypeSchema } from "@repo/shared";
import { API_V1_PREFIX, apiRequest, apiRequestJson } from "../api-client";

export const userAlertSchema = z.object({
  id: z.string(),
  title: z.string(),
  body: z.string(),
  type: alertTypeSchema,
  targetRoles: z.array(z.string()),
  createdAt: z.string(),
  updatedAt: z.string(),
  isRead: z.boolean(),
});

export type UserAlert = z.infer<typeof userAlertSchema>;

const userAlertListResponseSchema = z.object({
  data: z.array(userAlertSchema),
});

export async function listAlerts(): Promise<UserAlert[]> {
  const result = await apiRequestJson({
    path: `${API_V1_PREFIX}/alerts`,
    responseSchema: userAlertListResponseSchema,
    badResponseMessage: "Unexpected response from server",
  });
  return result.data;
}

export async function markAlertAsRead(alertId: string): Promise<void> {
  await apiRequest({
    path: `${API_V1_PREFIX}/alerts/${alertId}/read`,
    method: "POST",
  });
}
